import { render, staticRenderFns } from "./ApiTokensPage.vue?vue&type=template&id=672ffe45"
import script from "./ApiTokensPage.vue?vue&type=script&lang=ts"
export * from "./ApiTokensPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports